<template>
  <div>
    <label class="label">Código de segurança</label>
    <div class="code-inputs">
      <a-input
        v-for="(digit, index) in digitArray"
        :key="index"
        v-model="localCode[index]"
        :ref="(el) => (inputRefs[index] = el)"
        maxlength="1"
        class="code-box"
        :class="{ error: showError }"
        inputmode="numeric"
        @input="onInput(index, $event)"
        @keydown="onKeyDown(index, $event)"
        @focus="onFocus(index)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CodeInput",
  props: {
    digits: {
      type: Number,
      default: 6,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localCode: Array(this.digits).fill(""),
      inputRefs: [],
    };
  },
  computed: {
    digitArray() {
      return Array(this.digits).fill(0);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length === this.digits) {
          this.localCode = [...newVal];
        }
      },
    },
    showError(newVal) {
      if (newVal) {
        this.localCode = Array(this.digits).fill("");
        this.$nextTick(() => {
          this.focusFirst();
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.focusFirst();
    });
  },
  methods: {
    onInput(index, event) {
      let val = event.target.value;
      val = val.replace(/\D/g, "");

      if (val) {
        val = val.charAt(0);
        this.localCode[index] = val;

        if (index < this.digits - 1) {
          this.$nextTick(() => {
            this.focusInput(index + 1);
          });
        }
      }

      this.$emit("input", [...this.localCode]);

      const fullCode = this.localCode.join("");
      if (fullCode.length === this.digits) {
        this.$emit("complete", fullCode);
      }

      this.$emit("update:showError", false);
    },

    onKeyDown(index, event) {
      if (event.key === 'Backspace') {
        if (!this.localCode[index] && index > 0) {
          this.localCode[index - 1] = "";
          this.$emit("input", [...this.localCode]);
          this.$nextTick(() => {
            this.focusInput(index - 1);
          });
        }
        else if (this.localCode[index]) {
          this.localCode[index] = "";
          this.$emit("input", [...this.localCode]);
          this.$nextTick(() => {
            this.focusInput(index);
          });
        }
      }

      else if (event.key === 'ArrowLeft' && index > 0) {
        event.preventDefault();
        this.focusInput(index - 1);
      }

      else if (event.key === 'ArrowRight' && index < this.digits - 1) {
        event.preventDefault();
        this.focusInput(index + 1);
      }
    },

    onFocus(index) {
      this.$nextTick(() => {
        const input = this.inputRefs[index];
        if (input && input.$el && input.$el.querySelector('input')) {
          const inputElement = input.$el.querySelector('input');
          inputElement.select();
        }
      });
    },

    focusInput(index) {
      if (this.inputRefs[index] && this.inputRefs[index].focus) {
        this.inputRefs[index].focus();
      }
    },

    focusFirst() {
      this.focusInput(0);
    },

    clear() {
      this.localCode = Array(this.digits).fill("");
      this.$emit("input", [...this.localCode]);
      this.$nextTick(() => {
        this.focusFirst();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-weight: 600;
  font-size: 14px;
  color: #605f5f;
}
.code-inputs {
  display: flex;
  gap: 20px;

  .ant-input {
    width: 36px;
    height: 36px;
    text-align: center;
    font-size: 20px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    transition: border 0.2s;
    background-color: #ffffff;
    margin-top: 1rem;

    &.error {
      border-color: #ff4d4f;
    }

    &:focus {
      border-color: #ff7043;
      box-shadow: none;
    }
  }
}
</style>
